import { createSlice } from "@reduxjs/toolkit";
import { getOrders, fetchOrderDetail, updateOrder, getActivies, fetchReturnOrderDetail, getReturnActivies } from "./thunk";

export const initialState: any = {
    orders: [],
    orderDetail: null, 
    counts: 0,
    activies: []
};

const OrdersSlice = createSlice({
    name: 'OrdersSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
      builder.addCase(getOrders.fulfilled, (state: any, action: any) => {
            state.orders = action.payload.orders;
            state.counts = action.payload.counts;
        });

        builder.addCase(getOrders.rejected, (state: any, action: any) => {
            state.error = action?.payload?.error || null;
        });
      builder.addCase(getActivies.fulfilled, (state: any, action: any) => {
          state.activies = action.payload.activies;
      });
      builder
      .addCase(fetchReturnOrderDetail.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchReturnOrderDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.orderDetail = action.payload;
      })
      builder.addCase(getReturnActivies.fulfilled, (state: any, action: any) => {
        state.activies = action.payload.activies;
      });
  
      builder.addCase(getReturnActivies.rejected, (state: any, action: any) => {
        state.error = action?.payload?.error || null;
      });

      builder.addCase(getActivies.rejected, (state: any, action: any) => {
          state.error = action?.payload?.error || null;
      });
        builder
        .addCase(fetchOrderDetail.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(fetchOrderDetail.fulfilled, (state, action) => {
          state.loading = false;
          state.orderDetail = action.payload; 
        })
        .addCase(fetchOrderDetail.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload || 'Failed to fetch order detail';
        });
        builder.addCase(updateOrder.fulfilled, (state: any, action: any) => {
          state.status = action.payload.status;
        });
        builder.addCase(updateOrder.rejected, (state: any, action: any) => {
          state.error = action?.payload?.error || null;
        });
    },

    }
);

export default OrdersSlice.reducer;